/**
 * Created by Ning Jiang on 4/29/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {PixiesVsPiratesGameConfig} from "../PixiesVsPiratesGameConfig";
import {BitmapTextStyleData} from "../winpresentation/initial/PPWaysWonGFXText";

export class XWaysIndicatorView extends BaseView {

    private static _totalWaysPosition:[number, number] = [640, 593];

    private readonly _totalNumberStyle:BitmapTextStyleData = {
        fontName : "glowNumbers",
        fontSize : 40,
        tint :0xffffff
    };

    private _totalWays:PIXI.BitmapText;
    private _currentNumber:number;
    private _poof:TimelineSprite;
    private _totalWaysContainer:PIXI.Container;

    constructor() {
        super();
    }

    protected initAnimations():void {
        const layer:ScalableLayer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.X_WAYS_REEL.name);

        this._totalWaysContainer = new PIXI.Container();
        this._totalWaysContainer.position.set(XWaysIndicatorView._totalWaysPosition[0], XWaysIndicatorView._totalWaysPosition[1]);


        let waysStaticImage:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("waysText")[0]);
        waysStaticImage.anchor.set(0.5, 0.5);
        waysStaticImage.scale.set(0.5, 0.5);
        waysStaticImage.position.set(0, -20);
        this._totalWaysContainer.addChild(waysStaticImage)

        this._totalWays = new PIXI.BitmapText(" ", this._totalNumberStyle);
        (<PIXI.Point>this._totalWays.anchor).set(0.5, 0.5);
        this._totalWays.position.set(0, 11);
        // this._totalWays.position.set(XWaysIndicatorView._totalWaysPosition[0], XWaysIndicatorView._totalWaysPosition[1]);
        this._totalWaysContainer.addChild(this._totalWays);

        layer.addChild(this._totalWaysContainer);

        this._poof = new TimelineSprite(GameResources.getTextures("smallPoof"));
        this._poof.anchor.set(0.5);
        this._poof.scale.set(4);
        this._poof.visible = false;
        this._poof.position.set(XWaysIndicatorView._totalWaysPosition[0], XWaysIndicatorView._totalWaysPosition[1]);
        this._poof.blendMode = PIXI.BLEND_MODES.ADD;
        layer.addChild(this._poof);
    }

    public updateTotalWays(number:number, animate:boolean):void {
        // number = 11664;
        if(number === this._currentNumber) {
            return;
        }
        if(this._totalWays) {
            this._totalWays.text = number.toString();
            this._totalWays.updateTransform();
            if(animate) {
                this.playTotalWaysPoof();
            }
            this._currentNumber = number;
        }
    }

    public playTotalWaysPoof(isChangeMode:boolean = false):TimelineLite {
        let poofTimeLine:TimelineLite = new TimelineLite();
        if(this._poof) {
            poofTimeLine.add(() => {
                this._poof.x = this._totalWaysContainer.x;
                this._poof.getAnimationAutoShowHide();
            }, 0.1);
        }
        if(isChangeMode) {
            poofTimeLine.add(
                TweenLite.to(this._totalWaysContainer.scale, 0.4, {
                    x : 1.75,
                    y : 1.75,
                    ease : Elastic.easeOut.config(1, 1)
                }), 0.1);
            poofTimeLine.add(TweenLite.to(this._totalWaysContainer.scale, 0.8, {
                x : 1,
                y : 1,
                ease : Elastic.easeOut.config(1, 1)
            }));
        }
        return poofTimeLine;
    }
}